<template>
  <div class="form-group">
    <div class="form-header" v-if="label">
      <label>{{ label }}<span v-if="required" class="required">&nbsp;*</span></label>
    </div>

    <div class="form-inputs">
      <slot name="input"></slot>
    </div>

    <div class="form-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'form-group',

  props: {
    label: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false
    }
  }
}

</script>

<style lang="scss" scoped>

.form-group {
    width: 100%;
    .form-header{
        label {
            font-weight: 600;
            margin-bottom:6px;
            display: block;

            .required {
                color: #e74c3c
            }
        }
    }
    .form-inputs{
        > input {
            width: 100%;
            padding: 6px 10px;
            min-height: 40px;
        }
        margin-bottom:6px;
    }

    .form-footer{
        min-height: 17px;
    }
}
</style>

<style lang="scss">
.tags-input-default-class.tags-input {
    border:1px solid #dedede;
    padding:3px 8px;
    border-radius:4px;
}

.badge.badge-pill.badge-light {
    height: 23px;
    padding:0 8px;
    line-height:20px;
    font-size: 13px;
    background: rgba(0, 0, 0, 0.07);
    color: #707070;
    border-radius: 4px;
    display: inline-block;
    padding: 0 2px 0 8px;

    > span {
        display: inline-block;
        height: 23px;
        line-height: 23px;
        float: left;
    }

    .tags-input-remove{
        cursor: pointer;
        display:inline-block;
        float:right;
        width:20px;
        height:100%;
        background-repeat: no-repeat;
        background-size: 50%;
        background-position: center center;
        background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGhlaWdodD0iNTEycHgiIGlkPSJMYXllcl8xIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgd2lkdGg9IjUxMnB4IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48cGF0aCBkPSJNNDM3LjUsMzg2LjZMMzA2LjksMjU2bDEzMC42LTEzMC42YzE0LjEtMTQuMSwxNC4xLTM2LjgsMC01MC45Yy0xNC4xLTE0LjEtMzYuOC0xNC4xLTUwLjksMEwyNTYsMjA1LjFMMTI1LjQsNzQuNSAgYy0xNC4xLTE0LjEtMzYuOC0xNC4xLTUwLjksMGMtMTQuMSwxNC4xLTE0LjEsMzYuOCwwLDUwLjlMMjA1LjEsMjU2TDc0LjUsMzg2LjZjLTE0LjEsMTQuMS0xNC4xLDM2LjgsMCw1MC45ICBjMTQuMSwxNC4xLDM2LjgsMTQuMSw1MC45LDBMMjU2LDMwNi45bDEzMC42LDEzMC42YzE0LjEsMTQuMSwzNi44LDE0LjEsNTAuOSwwQzQ1MS41LDQyMy40LDQ1MS41LDQwMC42LDQzNy41LDM4Ni42eiIvPjwvc3ZnPg==');
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/form-group.vue